module.exports = __webpack_public_path__ + "img/17400.9d52948b.jpg";